import React from 'react';
import Modal from '../util/Modal';
import LoadingSpinner from '../util/LoadingSpinner';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';

export default class ConfirmationModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false
        }
    }

    async confirm() {
        const result = await this.props.confirm();
        // Prefer the value returned by confirm() so the outcome doesn't depend on
        // a parent setState having flushed to props by the time the await resolves.
        // Fall back to props.success for callers that don't return a value.
        const success = result === undefined ? this.props.success : result;
        if (success) {
            if(this.props.closeOnConfirm !== false) {
                this.props.close();
            }
        } else {
            this.setState({ error: true });
        }
    }

    close() {
        this.setState({ error: false });
        this.props.close();
    }

    render() {
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container" key='warningModal'>
                    <div className="modal confirmation-modal">
                      <h4 className="page-header"><i className="material-icons middle" style={{color: "#145214", marginRight: "8px"}}>check_circle_outline</i>{this.props.title || "Confirmation"}</h4>
                        <div className="modal-header">
                            <p className="medium-text"><span className="bold-text">{this.props.message}</span></p>
                        </div>
                        {this.props.loading ? <LoadingSpinner height="20" alignRight="true" /> : <div className="warning-modal-btns modal-btns text-right">
                            <button className="btn btn-accent" onClick={this.close.bind(this)}>No</button>
                            <button className="btn btn-accent2" onClick={this.confirm.bind(this)}>Yes</button>
                            <FadeOutErrorMessage show={this.state.error} message={this.props.errorMessage} />
                        </div>}
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/ConfirmationModal.jsx